import {Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable, of, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Router} from '@angular/router';
import {Apollo} from 'apollo-angular';
import {Institution} from '../../../../store/entities/system-settings/institution/institution.model';
import {GET_ALL_INSTITUTIONS_FEW} from '../../../../store/entities/system-settings/institution/institution.graphql';

@Component({
  selector: 'app-portal-institution-search',
  templateUrl: './portal-institution-search.component.html',
  styleUrl: './portal-institution-search.component.scss'
})
export class PortalInstitutionSearchComponent implements OnInit, OnDestroy {
  @Input() searchedKeyword = new FormControl('');
  @Output() exitHover = new EventEmitter<null>();

  filteredInstitutions: Observable<Institution[]> = of([]);
  router = inject(Router);
  apollo = inject(Apollo);
  private searchSub = Subscription.EMPTY;

  ngOnInit() {
    this.searchSub = this.searchedKeyword.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((keyword) => {
        if (keyword) {
          this.getSearchedInstitutions(keyword);
        } else {
          this.filteredInstitutions = of([]);
        }
      });
  }

  ngOnDestroy() {
    this.searchSub.unsubscribe();
  }

  onSearchChange() {
    if (this.searchedKeyword.value !== '') {
      this.getSearchedInstitutions(this.searchedKeyword.value);
    } else {
      this.filteredInstitutions = of([]);
    }
  }

  onItemSelected(institution: Institution) {
    this.searchedKeyword.setValue(institution?.institutionName, {emitEvent: false});
    this.exitHover.emit(null);
    this.router.navigate(['/service-by-group/institution'], {
      queryParams: {institutionUniqueId: institution?.institutionUniqueId}
    });
  }

  getSearchedInstitutions(keyword: string) {
    this.apollo
      .query({
        query: GET_ALL_INSTITUTIONS_FEW,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            pageNumber: 1,
            itemsPerPage: 20,
            keyword
          }
        },
      })
      .toPromise()
      .then(({data}: any) => {
        const result = data?.getAllInstitutions;
        if (result?.response?.status || result?.response?.code == 9000 || result?.response?.code == '9000') {
          this.filteredInstitutions = of(result.data ?? []);
        }
      });
  }
}
